import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { ErrorBoundary } from './components/ErrorBoundary';
import { Header } from './components/Header';
import { Footer } from './components/Footer';
import { HomePage } from './pages/HomePage';
import { PlaylistPage } from './pages/PlaylistPage';
import { PlaylistsPage } from './pages/PlaylistsPage';
import { SubmissionFlow } from './pages/SubmissionFlow';
import { GenreSelect } from './pages/GenreSelect';
import { GenrePage } from './pages/GenrePage';
import { SubGenrePage } from './pages/SubGenrePage';
import { GenreIndex } from './pages/GenreIndex';
import { AboutPage } from './pages/AboutPage';
import { ForCuratorsPage } from './pages/ForCuratorsPage';
import { BlogPage } from './pages/BlogPage';
import { BlogPostPage } from './pages/BlogPostPage';
import { BlogSubmitPage } from './pages/BlogSubmitPage';
// Admin imports removed - functionality deprecated

function App() {
  return (
    <ErrorBoundary>
      <div className="min-h-screen flex flex-col">
        <Routes>
          {/* Public routes */}
          <Route path="/" element={<><Header /><HomePage /><Footer /></>} />
          <Route path="/playlists" element={<><Header /><PlaylistsPage /><Footer /></>} />
          <Route path="/submit" element={<><Header /><SubmissionFlow /><Footer /></>} />
          <Route path="/submit/genre" element={<><Header /><GenreSelect /><Footer /></>} />
          <Route path="/playlist/:slug/*" element={<><Header /><PlaylistPage /><Footer /></>} />
          <Route path="/genres" element={<><Header /><GenreIndex /><Footer /></>} />
          <Route path="/genre/:genre" element={<><Header /><GenrePage /><Footer /></>} />
          <Route path="/genre/:genre/:subGenre" element={<><Header /><SubGenrePage /><Footer /></>} />
          <Route path="/about" element={<><Header /><AboutPage /><Footer /></>} />
          <Route path="/for-curators" element={<><Header /><ForCuratorsPage /><Footer /></>} />
          <Route path="/blog" element={<><Header /><BlogPage /><Footer /></>} />
          <Route path="/blog/submit" element={<BlogSubmitPage />} />
          <Route path="/blog/:category/:slug" element={<><Header /><BlogPostPage /><Footer /></>} />
          
          {/* Admin routes removed - deprecated functionality moved to backend */}

          {/* Fallback route */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </div>
    </ErrorBoundary>
  );
}

export default App;